import { Component } from '@angular/core';
import { Router, Routes, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import configApp from 'psapp-config';
import { AppService } from './app.service';
import { LoginProvider } from 'providers/login/login';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { TranslationProvider } from 'providers/translation/translation';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { Breakpoint, MessageService } from 'rb-core-library';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    //@ViewChild("sidebar") sidebar: any;//SidebarComponent;

    title = 'PS APP';
    menuItems: Routes = [];
    showMenu: boolean = true;
    user: any;

    profileImageSrc: string;

    public stickyBreakpoints = [ Breakpoint.SM ];
    
    constructor(
        private loginProvider: LoginProvider,
        private router: Router,
        private translateService: TranslateService,
        private translationProvider: TranslationProvider,
        private appService: AppService,
        private domainStorageProvider: DomainStorageProvider,
        public remoteServicesProvider: RemoteServicesProvider,
        public messageService: MessageService
    ) {

        this.messageService.popupMessage = null;

        this.menuItems = this.router.config.filter(x => x.data && (x.data.show === undefined || x.data.show));

        this.appService.onMainMenuEvent.subscribe((show) => {
            this.showMenu = show;
        });

        //WebTrekk
        this.appService.InitWebTrekk();
        this.router.events.subscribe( e => {
            if (e instanceof NavigationEnd) {
                var url = e.url;
                
                //ignore ranking 
                if (!url.startsWith("/ranking") && !url.startsWith("/login")) {
                    this.appService.SetWebTrekkPageView(url);
                }
            }
        });

        //handle http errors
        this.remoteServicesProvider.httpErrors.subscribe((err:HttpErrorResponse)=>{
            if(err.status == 401){
                this.messageService.addMessage({
                    type: 'danger',
                    text: this.translateService.instant("App.AccessDenied"),
                    timeout: 3000
                });

                this.loginProvider.logout();
                this.router.navigateByUrl("/login");
            }
            else if(err.status == 500){
                this.messageService.addMessage({
                    type: 'danger',
                    text: this.translateService.instant("App.UnexpectedError"),
                    timeout: 3000
                });
            }
            else {
                this.messageService.addMessage({
                    type: 'danger',
                    text: this.translateService.instant("App.TimeoutError"),
                    timeout: 3000
                });
            }
        })

        this.loadGmaps();
    }

    toggleSidebar() {
        //this.sidebar._toggleSidebar();
    }

    ngOnInit(): void {
        this.user = this.domainStorageProvider.rootStore.loginProvider;
        this.translateService.setDefaultLang(this.translationProvider.getDefaultLang());
        this.translateService.use(this.translationProvider.getCurrentLang());
    }

    private loadGmaps() {
        let GOOGLE_MAP_KEY = configApp.googleApiKey;
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
            "https://maps.googleapis.com/maps/api/js?v=quarterly" +
            "&key=" +
            GOOGLE_MAP_KEY +
            "&libraries=places"; //& needed
        document.body.appendChild(script);
    }
}
